import { db } from '../init';

export const clearDataPoints = async () => {
	try {
		await db.delete().then(() => db.open());
	} catch (error) {
		console.log(error);
	}
};
